import { Random } from '@framework/Random';
import { Timestamp } from '@framework/Timestamp';
import type { UnixTimestampMilliSeconds, UserSurveyAnswerJSON } from 'balus-common';

export class UserSurveyAnswer {
  constructor(
    public readonly surveyId: string,
    public readonly answeredAt: UnixTimestampMilliSeconds | null,
    public readonly canceledAt: UnixTimestampMilliSeconds | null
  ) {}

  dump(): UserSurveyAnswerJSON {
    return {
      surveyId: this.surveyId,
      answeredAt: this.answeredAt,
      canceledAt: this.canceledAt,
    };
  }

  static load(dump: UserSurveyAnswerJSON): UserSurveyAnswer {
    return new this(dump.surveyId, dump.answeredAt || null, dump.canceledAt || null);
  }

  static buildAnswerNew(origin: UserSurveyAnswer | null) {
    return new this(
      origin ? origin.surveyId : Random.generateRandomID(),
      Timestamp.now().toUnixTimestamp(),
      origin ? origin.canceledAt : null
    );
  }

  static buildCancelNew(origin: UserSurveyAnswer | null) {
    return new this(origin ? origin.surveyId : Random.generateRandomID(), null, Timestamp.now().toUnixTimestamp());
  }
}
